export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11416.a596bc5e.jpg";